// @flow

export const COMMIT_P2P_STATS = 'p2pStats/COMMIT_P2P_STATS'
export const RESET_P2P_STATS = 'p2pStats/RESET_P2P_STATS'

export const commitP2PStats = (stats: Object) => ({
  type: COMMIT_P2P_STATS,
  payload: stats,
})

export const resetP2PStats = () => ({
  type: RESET_P2P_STATS,
})
